import { CrmFieldService, StandardExternalIds } from '@galaxy/crm/static';
import { CrmObject } from '@vendasta/crm';

export interface Participant {
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
}

export function getFormattedDisplayName(found: Participant): string {
  let name = found?.firstName || '';
  if (found?.lastName) {
    if (name === '') {
      name = found?.lastName;
    } else {
      name += ' ' + found?.lastName;
    }
  }
  if (!name) {
    name = found?.email || '';
  }
  if (!name) {
    name = found?.phoneNumber || '';
  }
  return name;
}

export function getFormattedContactDisplayName(contact: CrmObject, fieldsService: CrmFieldService) {
  return getFormattedDisplayName({
    firstName: fieldsService.getFieldValueFromCrmObject(contact, StandardExternalIds.FirstName)?.stringValue || '',
    lastName: fieldsService.getFieldValueFromCrmObject(contact, StandardExternalIds.LastName)?.stringValue || '',
    email: fieldsService.getFieldValueFromCrmObject(contact, StandardExternalIds.Email)?.stringValue || '',
    phoneNumber: fieldsService.getFieldValueFromCrmObject(contact, StandardExternalIds.PhoneNumber)?.stringValue || '',
  });
}
